import React from 'react';
import { Users, Car, Clock, DollarSign, Heart, Award, ExternalLink } from 'lucide-react';

const Careers = () => {

  const benefits = [
    {
      icon: DollarSign,
      title: 'Competitive Pay',
      description: 'Above-market rates with opportunities for performance-based incentives and overtime.'
    },
    {
      icon: Clock,
      title: 'Flexible Scheduling',
      description: 'Part-time and full-time positions designed to support a range of availability.'
    },
    {
      icon: Car,
      title: 'Company Vehicles',
      description: 'Operate well-maintained, professional fleet vehicles.'
    },
    {
      icon: Award,
      title: 'Training & Development',
      description: 'Hands-on training and ongoing support to ensure confidence and success on the job.'
    },
    {
      icon: Users,
      title: 'Professional Environment',
      description: 'Work in a structured, team-oriented environment focused on reliability and service quality.'
    }
  ];


  return (
    <section id="careers" className="py-20 bg-navy-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Join Our Team</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Be part of a growing company that values professionalism, reliability, and customer service. At InTimelog, we're building a team focused on safety, consistency, and on-time performance.
          </p>
        </div>

        {/* Why Work With Us */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-white text-center mb-12">Why Choose Us?</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {benefits.map((benefit, index) => {
              const IconComponent = benefit.icon;
              return (
                <div key={index} className="
                 rounded-xl p-6 hover:bg-navy-700 transition-colors duration-200">
                  <div className="w-12 h-12 bg-primary-600 rounded-lg flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-white" />
                  </div>
                  <h4 className="text-lg font-semibold text-white mb-2">{benefit.title}</h4>
                  <p className="text-gray-300 text-sm leading-relaxed">{benefit.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Application CTA - COMMENTED OUT - Link leads nowhere for now */}
        {/* <div className="text-center bg-primary-600 rounded-2xl p-8 md:p-12">
          <h3 className="text-2xl font-bold text-white mb-4">Ready to Join Our Team?</h3>
          <p className="text-primary-100 text-lg mb-8 max-w-2xl mx-auto">
            We're always looking for talented professionals to join our team.
            View our current openings and apply through our career portal.
          </p>
          <button
            onClick={() => {
              // TODO: Add Paylocity URL when available
              alert('Career portal integration coming soon. Please contact us directly at careers@intimelog.com');
            }}
            className="inline-flex items-center px-8 py-4 bg-white text-primary-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors duration-200 shadow-lg"
          >
            <ExternalLink className="w-5 h-5 mr-2" />
            View Open Positions
          </button>
          <p className="text-primary-100 text-sm mt-4">
            Application portal powered by Paylocity
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default Careers;